import './style.css';
import { App } from './app';

const panel = document.getElementById('panel');
const viewport = document.getElementById('viewport');

if (!panel || !viewport) {
  throw new Error('Brak kontenera #panel lub #viewport w dokumencie.');
}

new App(panel, viewport);
